function normalizePathPrefix(value: string | undefined, fallback: string) {
  const candidate = (value || fallback).trim();
  if (!candidate || candidate === "/") {
    return "";
  }
  return `/${candidate.replace(/^\/+|\/+$/g, "")}`;
}

export const routerBasePath = normalizePathPrefix(import.meta.env.BASE_URL, "/");
export const apiBasePath = normalizePathPrefix(import.meta.env.VITE_API_BASE_PATH, "/api") || "/api";
export const publicBasePath = (() => {
  const base = import.meta.env.BASE_URL || "/";
  return base.endsWith("/") ? base : `${base}/`;
})();

export function buildApiUrl(path: string) {
  const candidate = path.trim();
  if (!candidate) {
    return apiBasePath;
  }
  if (/^(https?:)?\/\//i.test(candidate)) {
    return path;
  }

  if (
    candidate === apiBasePath ||
    candidate.startsWith(`${apiBasePath}/`) ||
    candidate.startsWith(`${apiBasePath}?`)
  ) {
    return candidate;
  }

  if (candidate === "/api" || candidate.startsWith("/api/") || candidate.startsWith("/api?")) {
    if (apiBasePath === "/api") {
      return candidate;
    }
    return `${apiBasePath}${candidate.slice("/api".length)}`;
  }

  const normalizedPath = candidate.startsWith("/") ? candidate : `/${candidate}`;
  return `${apiBasePath}${normalizedPath}`;
}

export function buildPublicAssetUrl(path: string) {
  if (/^(https?:)?\/\//i.test(path) || path.startsWith("data:")) {
    return path;
  }
  return `${publicBasePath}${path.replace(/^\/+/, "")}`;
}
